import { Model } from '../model';
import { Paginated } from '../paginated';
import { ButtonGroupRendererComponent } from '../../ui/components/atlas-grid/renderer/buttongroup-renderer.component';
import { AtlasGridOptions } from '../../ui/components/atlas-grid/altas-grid-options.model';
import { BrandName, flattenObject, formatCurrency, formatIntNumber, getCurrencySymbol, unique } from '../../utils/utils';

import { faSearch } from '@fortawesome/free-solid-svg-icons';
import { AtlasGridPriceRendererComponent } from '../../ui/components/atlas-grid/renderer/price-renderer.component';
import { ButtonRendererComponent } from '../../ui/components/atlas-grid/renderer/button-renderer.component';
import { AtlasGridIconRendererComponent } from '../../ui/components/atlas-grid/renderer/icon-renderer.component';
import { creditsTypeIcon } from '../../utils/constants';
import { SelectfilterRendererComponent } from '../../ui/components/atlas-grid/renderer/selectfilter-renderer.component';
import { InputfilterRendererComponent } from '../../ui/components/atlas-grid/renderer/inputfilter-renderer.component';
import { AtlasGridTranslateRendererComponent } from '../../ui/components/atlas-grid/renderer/translate-renderer.component';
import { SelectfilterPriorityRendererComponent } from '@ui/components/atlas-grid/renderer/selectfilter-priority-renderer.component';

// import {SmsService} from '../../services/sms.service';

export class SubShopItem extends Model {
  id?: string;
  label?: string;
  category?: string;
  monthsValidity?;
}

export class ShopItem extends Model {
  label?: string;
  items: Array<SubShopItem>;
  shop: any;
  translateService;
  sessionStorage;
  shopComponentInstance;
  translations;
  gridApi;
  itemoptions;
  isRenew?;
  isUpgrade?;
  note?: string;

  toRawValue(): object {
    return this.items.map(r => flattenObject(r));
  }

  isSmsCreditItem() {
    return this.label === 'list-sms-shop-items' || this.label === 'list-recurrent-shop-items';
  }

  loadTranslationsForShop() {
    const translations = [
      'shop_monthly',
      'shop_smsin_type_notshared',
      'shop_smsin_type_shared',
      'shop_smsin_type_shortcode_dedicated',
      'shop_smsin_type_shortcode_shared',
      'shop_subscription_plan',
      'shop_subscription_duration',
      'shop_subscription_monthprice',
      'shop_subscription_totalprice',
      'shop_smsin_number',
      'shop_sms_in_number_shared_keyword',
      'bundle_business',
      'bundle_enterprise',
      'bundle_pro',
      'bundle_test_1_label',
      'bundle_all',
      'saas_business',
      'saas_enterprise',
      'saas_pro',
      'saas_deliverplus',
      'saas_growplus',
      'saas_expandplus',
      'saas_pro',
      'saas_proplus',
      'saas_executive',
      'saas_executiveplus',
      'saas_premium',
      'saas_premiumplus',
      'saas_expand',
      'saas_enterprise',
      'saas_start',
      'saas_all_inclusive',
      'saas_1',
      'saas_2',
      'saas_3',
      'saas_4',
      'saas_5',
      'saas_6',
      'saas_7'
    ];
    return this.translateService.get(translations);
  }

  shopInit(shopComponentInstance, sessionStorage, translateService, itemoptions) {
    this.translateService = translateService;
    this.sessionStorage = sessionStorage;
    this.itemoptions = itemoptions;
    this.shopComponentInstance = shopComponentInstance;
    this.shop = {
      loaded: false,
      filters: {},
      customoptions: {}
    };

    // Exception for smsin for shared check

    this.loadTranslationsForShop().subscribe(translations => {
      this.translations = translations;
      this.shop = {
        loaded: true,
        showTable: this.showTable(),
        columns: this.getTableColumns(),
        data: this.getTableData(),
        options: this.getTableOptions(),
        components: this.getTablecomponents(),
        title: this.getTitle(),
        description: null,
        after: null,
        filters: {},
        customoptions: {}
      };
      this.getDescription();
      this.getAfter();
    });
  }

  getTitle() {
    if (this.label === 'list-sms-shop-items') {
      return 'shop_sms_title';
    }
    if (this.label === 'list-sms-shop-items') {
      return 'shop_recurrent_title';
    }
    if (this.label === 'list-srmo-shop-items') {
      return 'shop_srmo_title';
    }
    if (this.label === 'get-customized-package') {
      return null;
    }
    if (this.label === 'list-recurrent-shop-items') {
      return 'shop_recurrent_title';
    }
    if (this.label === 'list-rich-shop-items') {
      return 'subscription_type_rich_sms';
    }
    if (this.label === 'list-bundle-shop-items') {
      return 'list_bundle_shop_items';
    }
    // if (this.label === 'get-customized-package') {
    //   return 'shop_email';
    // }
    if (this.label === 'list-pages-shop-items' || this.label === 'list-pages-shop-items-renew') {
      return 'shop_pages';
    }
    if (this.label === 'list-sr-shop-items') {
      return 'shop_smsin_title';
    }
    if (this.label === 'list-sr-shop-items-renew') {
      return 'shop_smsin_renew_title';
    }
    if (this.label === 'list-bundle-shop-items-renew') {
      return 'list_bundle_shop_items_renew';
    }
    return this.label;
  }

  getDescription() {
    let keyDescription;
    switch (this.label) {
      case 'list-bundle-shop-items':
      case 'list-bundle-shop-items_renew':
        keyDescription = 'subscription_description_sms_bundle';
        break;
      case 'list-pages-shop-items':
      case 'list-pages-shop-items-renew':
        keyDescription = 'subscription_description_landing_page';
        break;
      case 'list-sr-shop-items':
      case 'list-sr-shop-items-renew':
        keyDescription = 'subscription_description_inbound_sms';
        break;
      case 'list-rich-shop-items':
        keyDescription = 'subscription_description_sms_link_analytics';
        break;
    }
    if (keyDescription) {
      this.translateService.get(keyDescription).subscribe(label => (this.shop.description = '<p>' + label + '</p>'));
    }
  }

  getAfter() {
    const brand = this.sessionStorage.retrieve('wsb-brand-name');

    if (this.label === 'list-sms-shop-items') {
      this.translateService.get('shop_sms_notes').subscribe(label => (this.shop.after = '<p>' + label + '</p>'));
    }
    if (this.label === 'list-bundle-shop-items' || this.label === 'list-bundle-shop-items_renew') {
      if (brand === BrandName.MEDIABURST) {
        this.translateService.get('shop_notes').subscribe(label => {
          this.shop.after =
            '<img class="w-960" src="\\assets\\images\\Uk-TA-WPG-Amend-TA-WSB-table-FY23Q2-FC-4399776103_new_new.png" /> <p class="mt-3">' +
            label +
            '</p>';
        });
      } else if (brand === BrandName.SKEBBY) {
        this.translateService.get('shop_notes').subscribe(label => {
          this.shop.after =
            '<img class="w-960" src="\\assets\\images\\skebby-Saas-Packages-Table-FY22Q3-FC_updated.png" /> <p>' + label + '</p>';
        });
      } else if (brand === BrandName.SMSENVOI) {
        this.translateService.get('shop_notes').subscribe(label => {
          this.shop.after =
            '<img class="w-960" src="\\assets\\images\\FranceSMS_FY22Q3_OldSAAS3.png" />' +
            '<img class="w-960" src="\\assets\\images\\FranceSMS_FY22Q3_NewSAAS7.png" /><p>' +
            label +
            '</p>';
        });
      } else if (brand === BrandName.MOBYTFR) {
        this.translateService.get('shop_notes').subscribe(label => {
          this.shop.after = '<img class="w-960" src="\\assets\\images\\FranceSMS_FY22Q3_NewSAAS7.png" /> <p class="mt-3">' + label + '</p>';
        });
      } else {
        this.translateService.get('shop_bundle_notes').subscribe(label => (this.shop.after = '<p>' + label + '</p>'));
      }
    }
    if (
      this.label === 'list-sr-shop-items' ||
      this.label === 'list-pages-shop-items-renew' ||
      this.label === 'list-pages-shop-items' ||
      this.label === 'list-rich-shop-items' ||
      this.label === 'list-srmo-shop-items'
    ) {
      this.translateService.get('shop_notes').subscribe(label => (this.shop.after = '<p>' + label + '</p>'));
    }
    // this.shop.after = this.label;
  }

  showInShop() {
    return this.items && this.items.length > 0;
  }

  showTable() {
    return true;
  }

  getTableColumns() {
    const that = this;
    const cols = [];
    switch (this.label) {
      case 'list-bundle-shop-items-renew':
        break;

      case 'list-pages-shop-items-renew':
      case 'list-pages-shop-items':
        cols.push({
          headerNameTranslate: 'shop_subscription_plan',
          sortable: false,
          cellRenderer: 'selectfilterRenderer',
          cellRendererParams: {
            options: () =>
              unique(
                this.items.map(x => {
                  return { label: (x as any).label, value: (x as any).label };
                }),
                'value'
              ),
            select: () => (that.shop.filters.label ? that.shop.filters.label : null),
            onChange: value => {
              that.shop.filters.label = value;
              that.shop.data = that.getTableData();
            }
          }
        });
        cols.push({
          headerNameTranslate: 'shop_subscription_duration',
          sortable: false,
          cellRenderer: 'selectfilterRenderer',
          cellRendererParams: {
            options: () =>
              unique(
                this.items.map(x => {
                  return { label: 'shop_duration_' + (x as any).monthsValidity, value: (x as any).monthsValidity };
                  // return {label: (x as any).label, value: (x as any).monthsValidity};
                }),
                'value'
              ),
            select: () => (that.shop.filters.monthsValidity ? that.shop.filters.monthsValidity : null),
            onChange: value => {
              that.shop.filters.monthsValidity = value;
              that.shop.data = that.getTableData();
            }
          }
        });
        cols.push({
          headerNameTranslate: 'shop_subscription_monthprice',
          sortable: false,
          valueGetter: params => {
            return params.data && params.data.unitPrice
              ? formatCurrency(params.data.unitPrice) + getCurrencySymbol() + ' ' + (that.translations as any).shop_monthly
              : '';
          }
        });
        cols.push({
          headerNameTranslate: 'shop_subscription_totalprice',
          sortable: false,
          valueGetter: params => {
            return params.data && params.data.price ? formatCurrency(params.data.price, { showSymbol: true }) : '';
          },
          cellClass: 'highlight'
        });
        cols.push({
          headerName: '',
          sortable: false,
          // headerNameTranslate: 'common_actions',
          cellRenderer: 'buttonRenderer',
          cellRendererParams: {
            onClick: e => {
              const options: any = {};
              if (this.isRenew) {
                options.operation = 'renew_service';
              }
              that.addToCart(e, options);
            },
            label: 'common_purchase',
            variant: 'primary',
            classes: 'smaller'
          },
          width: 310,
          cellClass: 'align-right'
        });

        break;
      case 'list-rich-shop-items':
      case 'list-srmo-shop-items':
        // cols.push({
        //   headerNameTranslate: 'shop_sms_price',
        //   field: 'price',
        //   valueGetter: params => {
        //     return formatCurrency(params.data.price, { showSymbol: true });
        //   },
        //   cellClass: 'highlight'
        // });
        cols.push({
          headerNameTranslate: 'shop_subscription_duration',
          sortable: false,
          cellRenderer: 'translateRenderer',
          cellRendererParams: {
            content: params => (params.node.data ? 'shop_duration_' + params.node.data.monthsValidity : '')
          },
          cellClass: 'highlight'
        });
        cols.push({
          headerNameTranslate: 'shop_subscription_totalprice',
          sortable: false,
          valueGetter: params => {
            return formatCurrency(params.data.price, { showSymbol: true });
          },
          cellClass: 'highlight'
        });
        cols.push({
          headerName: '',
          sortable: false,
          // headerNameTranslate: 'common_actions',
          cellRenderer: 'buttonRenderer',
          cellRendererParams: {
            onClick: e => {
              that.addToCart(e);
            },
            label: 'common_purchase',
            variant: 'primary',
            classes: 'smaller'
          },
          width: 310,
          cellClass: 'align-right'
        });

        break;
      case 'list-bundle-shop-items':
      case 'list-sr-shop-items':
        if (this.label !== 'list-bundle-shop-items') {
          cols.push({
            headerName: (this.translations as any).shop_subscription_plan,
            sortable: false,
            cellRenderer: 'selectfilterRenderer',
            cellRendererParams: {
              options: () =>
                unique(
                  this.items.map(x => {
                    let category = (x as any).category;
                    const simType = (x as any).serviceParams.simType;
                    // If simType is VMN and category is srv_sms, transform category to srv_smsd
                    if (simType === 'VMN' && category === 'srv_sms') {
                      category = 'srv_smsd';
                    }
                    return {
                      label:
                        category !== 'srv_smss'
                          ? simType === 'VMN'
                            ? (that.translations as any).shop_smsin_type_notshared
                            : (that.translations as any).shop_smsin_type_shortcode_dedicated
                          : simType === 'VMN'
                          ? (that.translations as any).shop_smsin_type_shared
                          : (that.translations as any).shop_smsin_type_shortcode_shared,
                      value: simType + '_' + category
                    };
                  }),
                  'value'
                ),
              select: () => (that.shop.filters.category ? that.shop.filters.category : null),
              onChange: value => {
                that.shop.customoptions = {};
                that.shop.filters.category = value;
                // that.shop.columns = that.getTableColumns();
                if (that.gridApi) {
                  that.gridApi.setColumnDefs(that.getTableColumns());
                  that.shop.data = that.getTableData();
                  setTimeout(() => {
                    that.gridApi.refreshHeader();
                    that.gridApi.sizeColumnsToFit();
                  });
                }
              },
              afterLoad: value => {
                that.shop.filters.category = value;
              }
            }
          });
        } else {
          // Bundle
          cols.push({
            headerName: (this.translations as any).shop_subscription_plan,
            sortable: false,
            cellRenderer: 'selectfilterRenderer',
            cellRendererParams: {
              options: () =>
                unique(
                  this.items.map(x => {
                    return {
                      label: (that.translations as any)[x.label],
                      value: (x as any).label
                    };
                  }),
                  'value'
                ),
              select: () => (that.shop.filters.label ? that.shop.filters.label : null),
              onChange: value => {
                that.shop.filters.label = value;
                // that.shop.columns = that.getTableColumns();
                if (that.gridApi) {
                  that.gridApi.setColumnDefs(that.getTableColumns());
                  that.shop.data = that.getTableData();
                  setTimeout(() => {
                    that.gridApi.refreshHeader();
                    that.gridApi.sizeColumnsToFit();
                  });
                }
              }
            }
          });

          if (this.isShowNumberDedicate(that)) {
            cols.push({
              headerName: (this.translations as any).shop_smsin_number,
              sortable: false,
              width: 250,
              cellRenderer: 'selectfilterPriorityRenderer',
              cellRendererParams: {
                optionsPriority: () => {
                  return this.itemoptions.availableSims.D43A.availableExclusiveSims.map(x => {
                    return { label: x, value: x };
                  });
                },
                options: () => {
                  return this.itemoptions.availableSims.VMN.availableExclusiveSims.map(x => {
                    return { label: x, value: x };
                  });
                },
                select: () => (that.shop.customoptions.number ? that.shop.customoptions.number : null),
                afterLoad: value => {
                  that.shop.customoptions.number = value;
                },
                onChange: value => {
                  that.shop.customoptions.number = value;
                  that.shop.data = that.getTableData();
                }
              }
            });
          }
        }

        if (that.shop.filters?.category?.includes('srv_smss')) {
          cols.push({
            headerName: (this.translations as any).shop_sms_in_number_shared_keyword,
            sortable: false,
            // headerNameTranslate: 'shop_smsin_number',
            cellRenderer: 'inputfilterRenderer',
            cellRendererParams: {
              onChange: value => {
                that.shop.customoptions.keyword = value;
                that.shop.data = that.getTableData();
              },
              onInput: value => {
                that.shop.customoptions.keyword = value;
                // that.shop.data = that.getTableData();
              },
              input: () => (that.shop.customoptions.keyword ? that.shop.customoptions.keyword : null),
              afterLoad: value => (that.shop.customoptions.keyword = value)
            }
          });
        }
        if (this.label !== 'list-bundle-shop-items') {
          cols.push({
            headerName: (this.translations as any).shop_smsin_number,
            sortable: false,
            // headerNameTranslate: '2shop_smsin_number',
            cellRenderer: 'selectfilterPriorityRenderer',
            width: 250,
            cellRendererParams: {
              optionsPriority: () => {
                switch (that.shop.filters.category) {
                  case 'VMN_srv_smsd':
                    return this.itemoptions.availableSims.D43A.availableExclusiveSims.map(x => {
                      return { label: x, value: x };
                    });
                    break;
                  case 'VMN_srv_smss':
                    return this.itemoptions.availableSims.D43A.availableSharedSims.map(x => {
                      return { label: x, value: x };
                    });
                    break;
                }
                return [];
              },
              options: () => {
                let defaultValue = false;
                switch (that.shop.filters.category) {
                  case 'VMN_srv_smss':
                    return this.itemoptions.availableSims.VMN.availableSharedSims.map(x => {
                      if (!defaultValue) {
                        // that.shop.customoptions.number = x ;
                        defaultValue = true;
                      }
                      return { label: x, value: x };
                    });
                    break;
                  case 'VMN_srv_smsd':
                    that.shop.showMore = true;
                    return this.itemoptions.availableSims.VMN.availableExclusiveSims.map(x => {
                      if (!defaultValue) {
                        // that.shop.customoptions.number = x ;
                        defaultValue = true;
                      }
                      return { label: x, value: x };
                    });
                    break;
                  case 'SHORTCODE_srv_smss':
                    return this.itemoptions.availableSims.SHORTCODE.availableSharedSims.map(x => {
                      if (!defaultValue) {
                        // that.shop.customoptions.number = x ;
                        defaultValue = true;
                      }
                      return { label: x, value: x };
                    });
                    break;
                  case 'SHORTCODE_srv_smsd':
                    return this.itemoptions.availableSims.SHORTCODE.availableExclusiveSims.map(x => {
                      if (!defaultValue) {
                        // that.shop.customoptions.number = x ;
                        defaultValue = true;
                      }
                      return { label: x, value: x };
                    });
                    break;
                }
              },
              onChange: value => {
                that.shop.data = that.getTableData();
                that.shop.customoptions.number = value;
              },
              select: () => (that.shop.customoptions.number ? that.shop.customoptions.number : null),
              afterLoad: value => {
                that.shop.customoptions.number = value;
              }
            }
          });
        }
        cols.push({
          headerName: (this.translations as any).shop_subscription_duration,
          sortable: false,
          cellRenderer: 'selectfilterRenderer',
          cellRendererParams: {
            options: () =>
              unique(
                this.getItemsFiltered(['monthsValidity']).map(x => {
                  return { label: 'shop_duration_' + (x as any).monthsValidity, value: (x as any).monthsValidity };
                }),
                'value'
              ),
            select: () => (that.shop.filters.monthsValidity ? that.shop.filters.monthsValidity : null),
            onChange: value => {
              that.shop.filters.monthsValidity = value;
              that.shop.data = that.getTableData();
            }
          }
        });
        cols.push({
          headerName: (this.translations as any).shop_subscription_monthprice,
          sortable: false,
          valueGetter: params => {
            return formatCurrency(params.data?.unitPrice) + getCurrencySymbol() + ' ' + (that.translations as any).shop_monthly;
          }
        });
        cols.push({
          headerName: (this.translations as any).shop_subscription_totalprice,
          sortable: false,
          valueGetter: params => {
            return formatCurrency(params.data?.price, { showSymbol: true });
          },
          cellClass: 'highlight'
        });
        if (this.label !== 'list-bundle-shop-items') {
          cols.push({
            headerName: '',
            sortable: false,
            // headerNameTranslate: 'common_actions',
            cellRenderer: 'buttonRenderer',
            cellRendererParams: {
              onClick: e => {
                const options: any = {};
                if (
                  that.shop.filters?.category?.includes('srv_smss')
                    ? that.shop.customoptions.keyword
                      ? false
                      : true
                    : that.shop.customoptions.number
                    ? false
                    : true
                ) {
                  that.shopComponentInstance.atlasToastService.error('common_error', null);
                } else {
                  options.sim = that.shop.customoptions.number;
                  if (that.shop.filters?.category?.includes('srv_smss')) {
                    options.keyword = that.shop.customoptions.keyword;
                  }
                  that.addToCart(e, options);
                }
              },
              label: 'common_purchase',
              variant: 'primary',
              classes: 'smaller'
              // disabled: () => that.shop.filters.category === 'srv_smss' ?
              //   (that.shop.customoptions.keyword ? false : true) :
              //   (that.shop.customoptions.number ? false : true)
            },
            width: 310,
            cellClass: 'align-right'
          });
        } else {
          // buy button for bundles
          cols.push({
            headerName: '',
            sortable: false,
            // headerNameTranslate: 'common_actions',
            cellRenderer: 'buttonRenderer',
            cellRendererParams: {
              onClick: e => {
                const options: any = {};
                if (this.isShowNumberDedicate(that)) {
                  options.sim = that.shop.customoptions.number;
                }
                that.addToCart(e, options);
              },
              label: 'common_purchase',
              variant: 'primary',
              classes: 'smaller'
            },
            width: 310,
            cellClass: 'align-right'
          });
        }

        break;
      case 'list-sr-shop-items-renew':
        cols.push({
          headerName: (this.translations as any).shop_subscription_plan,
          sortable: false,
          cellRenderer: 'selectfilterRenderer',
          cellRendererParams: {
            options: () =>
              unique(
                this.items.map(x => {
                  return {
                    label:
                      (x as any).category !== 'srv_smss'
                        ? (that.translations as any).shop_smsin_type_notshared
                        : (that.translations as any).shop_smsin_type_shared,
                    value: (x as any).category
                  };
                }),
                'value'
              ),
            select: () => (that.shop.filters.category ? that.shop.filters.category : null),
            onChange: value => {
              that.shop.filters = {};
              that.shop.filters.category = value;
              // that.shop.columns = that.getTableColumns();
              if (that.gridApi) {
                that.gridApi.setColumnDefs(that.getTableColumns());
                that.shop.data = that.getTableData();
                setTimeout(() => {
                  that.gridApi.refreshHeader();
                  that.gridApi.sizeColumnsToFit();
                });
              }
            },
            afterLoad: value => (that.shop.filters.category = value)
          }
        });
        cols.push({
          headerName: (this.translations as any).shop_smsin_number,
          sortable: false,
          // headerNameTranslate: '2shop_smsin_number',
          cellRenderer: 'selectfilterRenderer',
          cellRendererParams: {
            options: () =>
              unique(
                // filter has to ignore 'number','keyword'
                this.getItemsFiltered(['number', 'keyword']).map(x => {
                  return { label: (x as any).number, value: (x as any).number, notranslate: true };
                }),
                'value'
              ),
            onChange: value => {
              that.shop.filters.number = value;
              if (that.shop.filters.keyword) {
                // it needs to reset keyword
                that.shop.filters.keyword = undefined;
              }
              that.shop.data = that.getTableData();
            },
            select: () => (that.shop.filters.number ? that.shop.filters.number : null),
            afterLoad: value => (that.shop.filters.number = value)
          }
        });
        if (this.isShowKeywordForRenewSrvSmss(that.shop, that.items[0])) {
          cols.push({
            headerName: (this.translations as any).shop_sms_in_number_shared_keyword,
            sortable: false,
            // headerNameTranslate: 'shop_smsin_number',
            cellRenderer: 'selectfilterRenderer',
            cellRendererParams: {
              options: () =>
                unique(
                  this.getItemsFiltered(['keyword']).map(x => {
                    return { label: (x as any).keyword, value: (x as any).keyword, notranslate: true };
                  }),
                  'value'
                ),
              onChange: value => {
                that.shop.filters.keyword = value;
                that.shop.data = that.getTableData();
              },
              select: () => (that.shop.filters.keyword ? that.shop.filters.keyword : null),
              afterLoad: value => (that.shop.filters.keyword = value)
            }
          });
        }
        cols.push({
          headerName: (this.translations as any).shop_subscription_duration,
          sortable: false,
          cellRenderer: 'selectfilterRenderer',
          cellRendererParams: {
            options: () =>
              unique(
                this.getItemsFiltered(['monthsValidity']).map(x => {
                  return { label: 'shop_duration_' + (x as any).monthsValidity, value: (x as any).monthsValidity };
                }),
                'value'
              ),
            select: () => (that.shop.filters.monthsValidity ? that.shop.filters.monthsValidity : null),
            onChange: value => {
              that.shop.filters.monthsValidity = value;
              that.shop.data = that.getTableData();
            },
            afterLoad: value => (that.shop.filters.monthsValidity = value)
          }
        });
        // cols.push({
        //   headerName: (this.translations as any).shop_subscription_monthprice,
        //   valueGetter: params => {
        //     return formatCurrency(params.data.unitPrice) + getCurrencySymbol() + ' ' + (that.translations as any).shop_monthly;
        //   }
        // });
        // cols.push({
        //   headerName: (this.translations as any).shop_subscription_totalprice,
        //   valueGetter: params => {
        //     return formatCurrency(params.data.price, {showSymbol: true});
        //   },
        //   cellClass: 'highlight'
        // });
        cols.push({
          headerName: '',
          sortable: false,
          // headerNameTranslate: 'common_actions',
          cellRenderer: 'buttonRenderer',
          cellRendererParams: {
            onClick: e => {
              const options: any = {};
              options.operation = 'renew_sim';
              options.sim = that.shop.filters.number;
              options.monthsValidity = that.shop.filters.monthsValidity;
              if (that.shop.filters.keyword) {
                options.keyword = that.shop.filters.keyword;
              }
              that.addToCart(e, options);
            },
            label: 'common_purchase',
            variant: 'primary',
            classes: 'smaller'
            // disabled: () => that.shop.filters.category === 'srv_smss' ?
            //   (that.shop.customoptions.keyword ? false : true) :
            //   (that.shop.customoptions.number ? false : true)
          },
          width: 310,
          cellClass: 'align-right'
        });

        break;
      case 'get-customized-package':
      case 'list-recurrent-shop-items':
      case 'list-sms-shop-items':
        // private smsService: SmsService
        // this.smsService.getMessageTypes()
        cols.push({
          headerNameTranslate: 'shop_sms_price',
          sortable: false,
          field: 'price',
          valueGetter: params => {
            return formatCurrency(params.data.price, { showSymbol: true });
          },
          cellClass: 'highlight'
        });

        // Ugly way to get columns, better was the one commented below
        // if (this.items.length > 0 && (this.items[0] as any).pricePerMessageDetails) {
        //   for (let i = 0; i < (this.items[0] as any).pricePerMessageDetails.length; i++) {
        //     if (i === 0 || i === 1 || (this.items[0] as any).pricePerMessageDetails[i].idMessageType === 'EE') {
        if (that.shopComponentInstance.customizedPackFormTypes) {
          const smsTypes = that.shopComponentInstance.customizedPackFormTypes.slice(0);
          if (this.items.length > 0) {
            let hasEe = false;
            for (const item of this.items) {
              for (const priceDetail of (item as any).pricePerMessageDetails) {
                if (priceDetail.idMessageType === 'EE') {
                  smsTypes.push('EE');
                  hasEe = true;
                  break;
                }
              }
              if (hasEe) {
                break;
              }
            }

            for (const smsType of smsTypes) {
              cols.push({
                headerName: 'credit_type_' + smsType.toLowerCase(),
                sortable: false,
                headerComponent: 'iconRenderer',
                headerComponentParams: {
                  icon: creditsTypeIcon[smsType.toUpperCase()],
                  label: 'credit_type_' + smsType.toLowerCase(),
                  asterix: smsType.toUpperCase() === 'EE'
                },
                cellRenderer: 'priceRendererComponent',
                cellClass: smsType.toUpperCase() === 'EE' ? 'text-center' : '',
                cellRendererParams: {
                  firstRow: params =>
                    smsType.toUpperCase() !== 'EE' &&
                    params.data.defaultSmsPriceNations.filter(x => x.idMessageType === smsType.toUpperCase()).length
                      ? formatIntNumber(
                          params.data.defaultSmsPriceNations.filter(x => x.idMessageType === smsType.toUpperCase())[0].availableCredits
                        ) + ' sms'
                      : '',
                  secondRow: params =>
                    smsType.toUpperCase() !== 'EE' &&
                    params.data.defaultSmsPriceNations.filter(x => x.idMessageType === smsType.toUpperCase()).length
                      ? formatCurrency(
                          params.data.defaultSmsPriceNations.filter(x => x.idMessageType === smsType.toUpperCase())[0].unitPrice,
                          { keepDecimals: true }
                        ) +
                        ' ' +
                        getCurrencySymbol() +
                        '/sms'
                      : '',
                  buttonIcon: params =>
                    smsType.toUpperCase() === 'EE' &&
                    params.data.pricePerMessageDetails.filter(x => x.idMessageType === smsType.toUpperCase()).length
                      ? faSearch
                      : null,
                  buttonClick: e => this.shopComponentInstance.openModalInternationalRates(e)
                }
              });
            }
          }
        }
        cols.push({
          headerName: '',
          sortable: false,
          // headerNameTranslate: 'common_actions',
          cellRenderer: 'buttonRenderer',
          cellRendererParams: {
            onClick: e => {
              const options: any = {};
              if (this.label === 'get-customized-package') {
                options.messageType = (that as any).messagetype;
                // options['items-quantity'] = (that as any).itemquantity;
                options.quantity = (that as any).itemquantity;
                options.operation = 'customized_package';

                e.rowData.idShopItem = 'customized_package';
                e.rowData.category = 'sms';
              }
              that.addToCart(e, options);
            },
            label: 'common_purchase',
            variant: 'primary',
            classes: 'smaller'
          },
          width: 310,
          cellClass: 'align-right'
        });
        break;
    }
    return cols;
  }

  getItemsFiltered(ignore = []) {
    let items = this.items;
    if (this.shop && this.shop.filters) {
      if (this.shop.filters.category && (this.shop.filters.category.includes('VMN') || this.shop.filters.category.includes('SHORTCODE'))) {
        const itemsSr = [];
        for (const i in items) {
          if (items[i]) {
            const x = items[i];
            const category = this.shop.filters.category.includes('VMN') ? 'VMN_' + x.category : 'SHORTCODE_' + x.category;
            if ((x as any)?.serviceParams?.simType) {
              if (this.shop.filters.category.includes((x as any).serviceParams.simType)) {
                if (category === this.shop.filters.category) {
                  if (ignore.includes('monthsValidity') || !this.shop.filters.monthsValidity) {
                    itemsSr.push(x);
                  } else {
                    if (String(this.shop.filters?.monthsValidity) === String((x as any).monthsValidity)) {
                      itemsSr.push(x);
                    }
                  }
                }
              }
            }
          }
        }
        return itemsSr;
      } else {
        // filtering to compare items and with item selected
        Object.keys(this.shop.filters)
          .filter(x => !ignore.includes(x))
          .forEach(x => {
            items = items.filter(y => !this.shop.filters[x] || '' + String(y[x]) === String(this.shop.filters[x]));
          });

        // PWSB-2235: to avoid error display for  renew srv_smss
        // if items is empty then apply new filter with ignore keyword
        if (items.length === 0 && this.shop.filters.category) {
          if (this.shop.filters.category === 'srv_smss') {
            items = this.items;
            Object.keys(this.shop.filters)
              .filter(x => !'keyword'.includes(x))
              .forEach(x => {
                items = items.filter(y => !this.shop.filters[x] || '' + String(y[x]) === String(this.shop.filters[x]));
              });
          }
        }

        //  When we change packs with different monthsValidity
        //  if item label and monthsValidity doesn't matchs then we filter only label and set monthsValidity with first element
        const label = 'label';
        const monthsValidity = 'monthsValidity';
        if (items.length === 0 && this.shop.filters[label] && this.shop.filters[monthsValidity]) {
          items = this.items;
          items = items.filter(y => !this.shop.filters[label] || '' + String(y[label]) === String(this.shop.filters[label]));
          if (items.length > 0) {
            this.shop.filters.monthsValidity = String(items[0].monthsValidity);
          }
        }
      }

      // if (this.shop.filters.label) {
      //   return [this.items.filter(x => (x as any).label === this.shop.filters.label)[0]];
      // }
    }
    return items;
  }

  getTableData() {
    const items = this.getItemsFiltered();
    // console.log(this.label, items);
    if (
      this.label === 'list-pages-shop-items' ||
      this.label === 'list-pages-shop-items-renew' ||
      this.label === 'list-sr-shop-items' ||
      this.label === 'list-bundle-shop-items' ||
      this.label === 'list-sr-shop-items-renew'
    ) {
      return [items[0]];
    }
    return items;
  }

  getTableOptions() {
    return AtlasGridOptions.deserialize({
      rowHeight: 58,
      getApi: api => (this.gridApi = api),
      disablePagination: true,
      resizable: false
    });
  }

  getTablecomponents() {
    return {
      buttonRenderer: ButtonRendererComponent,
      buttonGroupRenderer: ButtonGroupRendererComponent,
      priceRendererComponent: AtlasGridPriceRendererComponent,
      iconRenderer: AtlasGridIconRendererComponent,
      selectfilterRenderer: SelectfilterRendererComponent,
      selectfilterPriorityRenderer: SelectfilterPriorityRendererComponent,
      inputfilterRenderer: InputfilterRendererComponent,
      translateRenderer: AtlasGridTranslateRendererComponent
    };
  }

  addToCart(item, options?) {
    return this.shopComponentInstance.addToCart(item, options);
  }

  private isShowNumberDedicate(that: any) {
    return that.getTableData()[0]?.serviceParams?.simType?.includes('VMN');
  }

  private isShowKeywordForRenewSrvSmss(shop, firstItem) {
    if (shop.filters.category || firstItem) {
      // first load, the shop.filters.category is undefinded
      if (shop.filters.category === undefined) {
        // check the category of firsrt item
        return firstItem.category === 'srv_smss';
      }

      return shop.filters.category === 'srv_smss';
    }
    return false;
  }
}

export class ShopItems extends Paginated {
  data: Array<ShopItem>;

  getItemsToShowInSmsFirstTab() {
    return this.data.filter((x: ShopItem) => {
      return x.isSmsCreditItem() && x.showInShop();
    });
  }

  getItemsToShowInSmsSecondTab() {
    return this.data.filter((x: ShopItem) => {
      return !x.isSmsCreditItem() && x.showInShop();
    });
  }

  isActiveTrialLandingPage() {
    let isActive = false;
    const itemTrial = this.getItemTrialLandingPage();
    if (itemTrial) {
      const isNote = itemTrial?.note ? true : false;
      isActive = itemTrial.items.length === 0 && isNote;
    }
    return isActive;
  }

  getItemTrialLandingPage(): ShopItem {
    return this.data.find((x: ShopItem) => {
      return x.label === 'list-pages-shop-items';
    });
  }
}
